import { LivestreamState, Media } from '#types/generated/graphql-types';

const mapDetailsButtonLabel = (media: Media): string => {
  const streamState = media?.details?.streamState;

  switch (streamState) {
    case LivestreamState.Upcoming:
    case LivestreamState.PreLive:
      return 'teaserButtonDetailsLivestreamUpcoming';
    case LivestreamState.Live:
      return 'teaserButtonDetailsLivestreamLive';
    case LivestreamState.Ended:
      return 'teaserButtonDetailsLivestreamEnded';
    default:
      return 'teaserButtonDetails';
  }
};

export default mapDetailsButtonLabel;
